<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {roleFilterText} from "@/utils/roleFilter.js"
export default {
  mounted() {
    const name = roleFilterText(this.$store.state.region);
    if(name!=undefined && name!=''){
    	document.title = `${name}职业院校技能大赛-教学能力大赛`;
    }else{
      document.title = "金石榴网络育人创新联盟平台";
    }
  },
};
</script>
<style lang="scss">
@import "./assets/style/base.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-white;
  width:100%;
  overflow: hidden;
}
.ant-table-align-center {
  // background: #ffe1bf !important;
  font-size: 16px !important;
  font-weight: 600;
  color: #000 !important;
  // border-right: 1px solid #fcbd76 !important;
}
.ant-table-align-center:last-child {
  border-right: 1px solid #e8e8e8 !important;
}
.ant-tree {
  color: #9A0B00 !important;
}
.ant-tree li .ant-tree-node-content-wrapper {
  font-size: 16px !important;
  font-family: Microsoft YaHei !important;
  font-weight: bold !important;
  color: #9A0B00 !important;
}
.ant-tree li ul li .ant-tree-node-content-wrapper {
  font-size: 16px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 400 !important;
  color: #3c3c3c !important;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  background: none !important;
}

.ant-card-body {
  padding: 20px 0px !important;
}
.ant-upload-list-item {
  width: 500px !important;
}
.ant-upload-list-item-info i,
.ant-upload-list-item-info span {
  color: #9A0B00 !important;
}
.ant-tree-treenode-switcher-close {
  overflow: hidden !important;
}
.ant-tree-treenode-switcher-open {
  overflow: hidden !important;
}
.ant-tree-node-content-wrapper {
  flex: 1;
}
.ant-btn-primary {
  background-color: #9A0B00 !important;
  border: none !important;
}
</style>
